module.exports = __webpack_public_path__ + "img/icon-phone.75baa0a8.svg";